import PropTypes from 'prop-types';
import React from 'react';
import { Dialog, CardActions } from 'react-toolbox';
import { confirmable } from 'react-confirm';
import ColoredButton from 'components/ColoredButton';
import MessageBox from 'components/MessageBox';
import styles from 'styles/form.scss';
import inputStyles from 'styles/exportModalInput.scss';
import cx from 'classnames';

const cancelClass = cx([styles.cancelButton, styles.actionButton]);
const cardActionsClass = cx([styles.actionsWrapper, styles.rightDown]);
const inputClass = cx([styles.inputArea, inputStyles.export]);
class ExportDialog extends React.Component {
  render() {
    const { show, proceed, dismiss, cancel, confirmation, error, ...options } = this.props;
    const { title, theActions } = options;
    const actions = theActions || ['Cancel', 'OK'];

    return (
      <Dialog
        active={show}
        onEscKeyDown={dismiss}
        onOverlayClick={dismiss}
        title={title || 'Export confirmation'}
      >
        {confirmation}
        <div className={inputClass}>
          <input type="text" ref={el => (this.pageInput = el)} placeholder="Default: Page 1" />
          <span className="highlight" />
          <span className="bar" />
        </div>
        {error && <MessageBox message={error} error />}
        <CardActions className={cardActionsClass}>
          {actions.indexOf('Cancel') > -1 ? (
            <ColoredButton
              className={cancelClass}
              responsive
              color="gray"
              label={options.cancelLabel || 'Cancel'}
              onClick={cancel}
            />
          ) : null}
          {actions.indexOf('OK') > -1 ? (
            <ColoredButton
              className={styles.actionButton}
              responsive
              color="green"
              label={options.okLabel || 'OK'}
              onClick={() => {
                proceed(this.pageInput.value);
              }}
            />
          ) : null}
        </CardActions>
      </Dialog>
    );
  }
}

ExportDialog.propTypes = {
  show: PropTypes.bool,
  proceed: PropTypes.func,
  dismiss: PropTypes.func,
  cancel: PropTypes.func,
  confirmation: PropTypes.node,
  error: PropTypes.string,
};

export default confirmable(ExportDialog);



// WEBPACK FOOTER //
// ./client/app/shared/components/ConfirmDialog/export.jsx